var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("validation-provider", {
            attrs: { rules: "area", name: _vm.nomeAba + "/Área (ha)" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c("Label", {
                          attrs: { label: "Área (ha) ", obrigatorio: true }
                        }),
                        _vm._v(" "),
                        _c("InputDouble", {
                          class: { erro: errors.length, input: "input" },
                          attrs: {
                            name: "Área (ha) ",
                            precision: 2,
                            onkeypress: _vm.onlyInputNumbers,
                            showAppend: true
                          },
                          model: {
                            value: _vm.pratica.area,
                            callback: function($$v) {
                              _vm.$set(_vm.pratica, "area", $$v)
                            },
                            expression: "pratica.area"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("validation-provider", {
            attrs: {
              rules: "required",
              name: _vm.nomeAba + "/Data de início (mês/ano)"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c("Label", {
                          attrs: {
                            label: "Data de início (mês/ano)",
                            obrigatorio: true
                          }
                        }),
                        _vm._v(" "),
                        _c("el-date-picker", {
                          class: { erro: errors.length, input: "input" },
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "month",
                            placeholder: "Selecione mês e ano",
                            format: "MM/yyyy",
                            "value-format": "yyyy-MM-dd"
                          },
                          model: {
                            value: _vm.pratica.dataInicio,
                            callback: function($$v) {
                              _vm.$set(_vm.pratica, "dataInicio", $$v)
                            },
                            expression: "pratica.dataInicio"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "validation-provider",
            [
              _c("InputSelect", {
                attrs: {
                  label: "Modalidade adotada",
                  obrigatorio: true,
                  rulesInput: "required",
                  opcoes: _vm.modalidades,
                  "multi-select": true,
                  widthColumn: 12
                },
                model: {
                  value: _vm.pratica.modalidades,
                  callback: function($$v) {
                    _vm.$set(_vm.pratica, "modalidades", $$v)
                  },
                  expression: "pratica.modalidades"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.temLavoura
        ? _c("ilpf-lavoura", {
            attrs: { culturas: _vm.culturas, pratica: _vm.pratica }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.temPecuaria
        ? _c("ilpf-pecuaria", {
            attrs: { "tipos-criacao": _vm.tiposCriacao, pratica: _vm.pratica }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.temFloresta
        ? _c("ilpf-floresta", {
            attrs: {
              "especies-florestais": _vm.especiesFlorestais,
              pratica: _vm.pratica
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("Bioinsumos", {
        attrs: { pratica: _vm.pratica, nomeAba: _vm.nomeAba }
      }),
      _vm._v(" "),
      _c("Irrigacao", {
        attrs: { pratica: _vm.pratica, nomeAba: _vm.nomeAba }
      }),
      _vm._v(" "),
      _c("Financiamentos", {
        attrs: { pratica: _vm.pratica, nomeAba: _vm.nomeAba }
      }),
      _vm._v(" "),
      _c("TitleWithRow", { attrs: { title: "" } }),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("Label", { attrs: { label: "Descrição" } }),
              _vm._v(" "),
              _c("el-input", {
                attrs: {
                  name: "Descrição",
                  type: "textarea",
                  maxlength: "500",
                  "show-word-limit": ""
                },
                model: {
                  value: _vm.pratica.descricao,
                  callback: function($$v) {
                    _vm.$set(_vm.pratica, "descricao", $$v)
                  },
                  expression: "pratica.descricao"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74e96b37", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74e96b37","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App/(authenticated)/modulos/cadastro/formulario-cadastro/praticas/form-praticas/ILPF/ILPF.vue
// module id = null
// module chunks = 